import { Empty, Skeleton, Table, Row, Col, Spin } from "antd"
import React from "react"
import { useConfig } from "../../contexts/ConfigContext"
import { modules } from "../../config/pages"
import { useRegister } from "../../contexts/RegisterContext"
import CardListView from "./storage-list/CardListView"

function DataViewList (props:any){
  const {config} = useConfig()
  const {register} = useRegister()
  const showHeaderElement = !!props.headerElement
  return (
    <div className="container-fluid">
      <Spin size="large" tip="Cargando..." fullscreen spinning={props.spinning} />
      {config.isMobile && <div style={{marginBottom:"1.5rem",alignItems:"center",justifyContent:"space-between",display:"flex"}}>
        <h1 className="title-content">{props.title}</h1>
      </div>}   
      <div className="card shadow" style={{marginBottom:"1.5rem"}}>
        <div className="card-header" style={{paddingTop:"0.75rem", paddingBottom:"0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem"}}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px 16px" }}>
            {(!config.isMobile || !showHeaderElement) && (
              <h6 className="font-weight-bold text-primary" style={{margin:0, fontSize: '1.2rem', whiteSpace: "nowrap"}} >{props.title || 'Datos de registro'}</h6>
            )}
            {showHeaderElement && (
              <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", flex: "1 1 auto", justifyContent: "flex-end" }}>
                {typeof props.headerElement === 'function' ? props.headerElement() : props.headerElement}
              </div>
            )}
          </div>
        </div>
        <div className="card-body">
          {(register.storageViewType === "TABLE" || config.module !== modules.StorageItemList) && 
          <Skeleton active paragraph={{ rows: 6 }} loading={props.skeleton}>
            <Table
              columns={props.tableColumns}
              dataSource={props.dataTable}
              pagination={props.pagination || (props.dataTable?.length > 10 ? undefined : false)}
              scroll={{x:config.module === modules.StorageItemList ? 1100 : 'max-content'}}
              onRow={props.onRow}
              locale={{emptyText:<Empty description={props.emptyMessage}></Empty>}}>
            </Table>
          </Skeleton> }
          {register.storageViewType === "LIST" && config.module === modules.StorageItemList &&
          <Skeleton active paragraph={{ rows: 6 }} loading={props.skeleton}>
            <CardListView dataTable={props.dataTable} onClick={props.onRow} pagination={props.pagination}/>
          </Skeleton> }
        </div>
      </div>
      {props.footerElement && (typeof props.footerElement === 'function' ? props.footerElement() : props.footerElement)}
      {props.modal && (typeof props.modal === 'function' ? props.modal() : props.modal)}
    </div>
  )
}

export default DataViewList